<div class="component-report-main">
  <div class="component-report-main__search-bar">
    <app-search [placeholderText]="'Search reports by name, owner, tag, or system…'"></app-search>
  </div>
  <div class="grid-flex">
    <app-left-view></app-left-view>
    <router-outlet></router-outlet>
  </div>
</div>
